import { render, staticRenderFns } from "./IsoscelesTriangleViz.vue?vue&type=template&id=c635f9c2&scoped=true"
import script from "./IsoscelesTriangleViz.vue?vue&type=script&lang=js"
export * from "./IsoscelesTriangleViz.vue?vue&type=script&lang=js"
import style0 from "./IsoscelesTriangleViz.vue?vue&type=style&index=0&id=c635f9c2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c635f9c2",
  null
  
)

export default component.exports